<div class="modal" tabindex="-1">
    <div class="modal-dialog">
        <div class="modal-content p-0">
            <div class="modal-body">
                <button type="button" (click)="close()" class="btn-close" style="position: absolute; top:15px; right: 15px; z-index: 1"></button>
                <h3 class="fs-3 fw-bold mt-3 mb-0">Product Pricing</h3>
                <hr class="my-4">
                <div class="px-5">
                    <div class="text-primary text-start mb-4">
                        We are able to offer various levels of discount, depending on the amount you choose to buy. The
                        larger the quantity the greater the saving. Please take a look at the pricing structure for your
                        selected product below.
                    </div>
                    <table class="table text-primary text-end" *ngIf="product">
                        <thead>
                        <tr>
                            <th scope="col" class="ff-spectral ff-bold pe-2 text-start">Size</th>
                            <th scope="col" class="ff-spectral ff-bold pe-2">Min. Units</th>
                            <th scope="col" class="ff-spectral ff-bold pe-2">Max. Units</th>
                            <th scope="col" class="ff-spectral ff-bold pe-2">Price Band</th>
                            <th scope="col" class="ff-spectral ff-bold pe-2">Saving Per Unit</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let priceBreak of product.productDetails; let i = index; let first = first">
                            <td class="py-2 pe-2 text-start">{{ priceBreak.size.name }}</td>
                            <td class="py-2 pe-2">{{ priceBreak.minQty }}</td>
                            <td class="py-2 pe-2">{{ priceBreak.maxQty }}</td>
                            <td class="fw-bold py-2 pe-2">{{ priceBreak.price | currency: 'GBP' : 'symbol' : '1.0-0' }}</td>
                            <td class="py-2 pe-2">
                                <ng-container *ngIf="first">
                                    {{ 0 | currency: 'GBP' : 'symbol' : '1.0-0'  }}
                                </ng-container>
                                <ng-container *ngIf="!first">
                                    {{ +breaks[priceBreak.skuId].price - +priceBreak.price | currency: 'GBP' : 'symbol' : '1.0-0' }}
                                </ng-container>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
